var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"video_table",class:!_vm.navInfo.navFlag ? 'video_table_close' : ''},[_c('div',{staticClass:"table_title"},[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.close}}),_c('div',{staticClass:"title"},[_vm._v("设置")])]),(_vm.layerName == 'background')?_c('SetCon1'):_c('SetCon2',{attrs:{"type":_vm.layerName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }